import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { EdpStepList } from "@edp-models/edp-step-list.model";

@Component({
  selector: "edp-side-steps",
  templateUrl: "./edp-side-steps.component.html",
  styleUrls: ["./edp-side-steps.component.scss"]
})
export class EdpSideStepsComponent implements OnInit, OnChanges {

  @Input() step = 1;
  @Input() steps: Array<EdpStepList> = [];
  @Output() backStep = new EventEmitter<any>();
  active: EdpStepList;
  stepsNumber: Array<number> = [];

  constructor() { }

  ngOnInit() { }

  ngOnChanges(): void {
    this.active = this.steps.find(i => i.step === this.step);
    this.stepsNumber = this.steps.map(i => i.step);
  }

}
